import { render, staticRenderFns } from "./configuracoesEditar.vue?vue&type=template&id=d86c09e6&scoped=true&"
import script from "./configuracoesEditar.vue?vue&type=script&lang=js&"
export * from "./configuracoesEditar.vue?vue&type=script&lang=js&"
import style0 from "./configuracoesEditar.vue?vue&type=style&index=0&id=d86c09e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86c09e6",
  null
  
)

export default component.exports